<app-page-header
  title="Tipos de documento"
  mobileTitle="Tipos doc."
  icon="fas fa-file-signature"
  optionsLabel="Opciones"
  optionsIcon="fa fa-cog"
  [hasOptions]="!showMobileDetail"
  [showBack]="showMobileDetail"
  [unifiedOnMobile]="showMobileDetail"
  (back)="closeDetail()">
  <div headerOptions>
    @if (perm.canCurrent('canCreate')) {
      <a class="dropdown-item" (click)="newType()">
        <i class="fas fa-plus fa-fw me-2 text-primary"></i> Nuevo tipo
      </a>
    }
  </div>
</app-page-header>

@if (!showMobileDetail) {
  <div class="row">
    <div class="col-12" [class.mobile-requests-container]="appSettings.isMobile()">
      <div class="mobile-list-shell" [class.panel]="!appSettings.isMobile()" [class.p-3]="!appSettings.isMobile()">
        <app-doc-ref-list (selectEvent)="onTypeSelected($event)">
          @if (perm.canCurrent('canCreate')) {
            <button class="btn btn-primary btn-sm" (click)="newType()">
              <i class="fas fa-plus"></i> Nuevo tipo
            </button>
          }
        </app-doc-ref-list>
      </div>
    </div>
  </div>
} @else {
  <div class="panel p-3 mb-3">
    <h5 class="mb-3">{{ mode() === formMode.CREATE ? 'Nuevo tipo' : 'Editar tipo' }}</h5>
    <app-doc-ref-form [documentTypeForm]="documentTypeForm" [mode]="mode()"></app-doc-ref-form>
  </div>
  <app-mobile-footer [visible]="true">
    <button type="button" class="btn btn-primary btn-sm"
      [disabled]="documentTypeForm.invalid"
      (click)="saveType()">
      Guardar
    </button>
  </app-mobile-footer>
}

<ng-template #typeModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ mode() === formMode.CREATE ? 'Nuevo' : 'Editar' }} tipo de documento</h4>
  </div>
  <div class="modal-body">
    <app-doc-ref-form [documentTypeForm]="documentTypeForm" [mode]="mode()"></app-doc-ref-form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="close()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="saveType()"
      [disabled]="documentTypeForm.invalid">
      Guardar
    </button>
  </div>
</ng-template>
